@if (flagType(); as flag) {
  <span
    class="badge badge-light me-2 mb-2 existing-flag-badge icon-category-{{ flag.company_flag_category_key }}"
    [class.dashboard-icon-variant]="iconVariant() === 'dashboard'"
    [class.flag-tag-large]="size() === 'large'"
    [popover]="flagPopover"
    [outsideClick]="true"
    placement="top"
    container="body"
    containerClass="existing-flag-popover"
    role="button"
    tabindex="0">
    <nk-company-flag-icon
      class="d-inline-block me-1"
      [companyFlagCategoryKey]="flag.company_flag_category_key"
      [companyFlagTypeAppIconUuid]="flag.app_icon_uuid"></nk-company-flag-icon>
    {{ 'company_flag.' + flag.company_flag_type_key | translate }}
  </span>
  <ng-template #flagPopover>
    @if (composite(); as c) {
      <nk-company-flag-context-content
        [companyFlagComposite]="c"
        [showEvidence]="true"
        [showDescription]="true"
        [showHeader]="true"
        [showDate]="true"
        [compact]="false"></nk-company-flag-context-content>
    } @else {
      <h6 class="fw-bold mb-2">{{ 'company_flag.' + flag.company_flag_type_key | translate }}</h6>
      <p class="mb-0 text-muted">
        {{ 'company_flag_type_description.' + flag.company_flag_type_key | translate }}
      </p>
    }
  </ng-template>
}
